import React from 'react';
import './custom.css'

const Mining = () => {

    return (
        <>
            <section id='mining' className='mx-3 '>
                <div className='text-center'>
                    <h1 data-aos="flip-up" className='mining_header'>Mining</h1>
                    <span className='mining_span'>A green way of mining crypto</span>
                </div>
                <div className='mining_para d-none d-md-block'>
                    <p className='minig_text' data-aos="fade-up" data-aos-duration="2000">Most of the Cryptocurrencies operate on proof of work (PoW) which relies on mining new coins and adding new blocks of ​information to a digital currency blockchain.
                        The Cambridge Bitcoin Electricity Consumption Index indicates that Bitcoin, the most widely-mined cryptocurrency network, ​uses 122.87 Terawatt-hours of electricity every year, which equals the amount of power consumed by the average American ​household over 72.2 days.</p>
                </div>
                <div className='mt-3 d-block d-md-none' style={{ textAlign: 'center' }}>
                    <p className='minig_text' style={{ color: 'black' }}>Most of the Cryptocurrencies operate on proof of work (PoW) which relies on mining new coins and adding new blocks of ​information to a digital currency blockchain.
                        The Cambridge Bitcoin Electricity Consumption Index indicates that Bitcoin, the most widely-mined cryptocurrency network, ​uses 122.87 Terawatt-hours of electricity every year, which equals the amount of power consumed by the average American ​household over 72.2 days.</p>
                </div>
                <div data-aos="fade-up" data-aos-duration="2000" className='text-center'>
                    <h1 className='second_header_mining'>For O2Club PoW mean carbon neutral action</h1>
                    <p className='minig_earn '>Ea​rn Token for green actions</p>
                </div>
                <div className='d-flex justify-content-center mt-5'>
                    <div data-aos="zoom-in-up" className='row'>
                        <div className='col-md-4'>
                            <div className='px-5 py-4 d-flex justify-content-center lastImg lastImgI'>
                                <img width='90px' className='py-3' src='/img/mani-1.png' alt="" />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className=''>
                                <div className='px-5 py-4 d-flex justify-content-center lastImg lastImgj' >
                                    <img className='py-3' width='90px' src='/img/mani-2.png' alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='px-5 py-4 d-flex justify-content-center lastImg lastImgj'>
                                <img className='py-3' width='90px' src='/img/mani-3.png' alt="" />
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </>
    );
};

export default Mining;